import { useViewPort } from "@website/hooks/viewport";
import { MaterialIcon } from "@website/icons/material";
import { DropdownPropertiesType } from "@website/ui/dropdown/dropdown.types";
import { useEffect, useState } from "react";

export const useDropdown = (properties: DropdownPropertiesType) => {
  const {
    size = "default",
    helperText,
    label,
    StartIcon,
    onStartIconClick,
    onChange,
    fullWidth,
    disabled,
    list,
    value,
    name,
    placeholder,
    error,
    divider,
    defaultValue,
    textFieldOtherProperties = {},
    autoComplete,
    popoverTitle
  } = properties;
  const [open, setOpen] = useState<boolean>(false);
  const { isMobile } = useViewPort();

  const onClosePopover = () => {
    setOpen(false);
  };

  // const onFocusTextField = () => {
  //   setOpen(true);
  // }

  // const onBlurTextField = () => {
  //   setOpen(false);
  // }

  const onClickTextField = () => {
    setOpen(true);
  };

  useEffect(() => {
    if (open) {
      const menuScrollTimeout = setTimeout(() => {
        const menu = document.querySelector<HTMLDivElement>(
          `[data-testid="muenu"]`
        );
        menu?.scrollIntoView({ block: "end", behavior: "smooth" });
      }, 100);

      return () => clearTimeout(menuScrollTimeout);
    }
  }, [open]);

  const onChangeTextField = () => {
    // no need to do anything
  };

  const onChangeMenu = (value: string) => {
    onChange(value);
    setOpen(false);
  };

  const selectedItem = list.find((item) => item.value === value);

  return {
    rootProps: {
      // ...pick(props, "aria-label", "onClick", "type"),
      // disabled: props.disabled || props.loading,
    },
    textfieldProps: {
      // onFocus: onFocusTextField,
      // onBlur: onBlurTextField,
      ...textFieldOtherProperties,
      onClick: onClickTextField,
      onChange: onChangeTextField,
      size,
      helperText,
      label,
      EndIcon: <MaterialIcon name="arrow_drop_down" variant="fill" />,
      StartIcon,
      onStartIconClick,
      fullWidth,
      disabled,
      value: selectedItem?.title || "",
      name,
      placeholder,
      error,
      defaultValue,
      autoComplete
    },
    popoverProps: {
      animate: "bottom" as const,
      open,
      title: isMobile ? label || popoverTitle : undefined,
      onClose: onClosePopover,
      size,
      hideCloseButton: true,
      fullWidth: true
    },
    menuProps: {
      onChange: onChangeMenu,
      name,
      list,
      value,
      divider,
      size
    }
  };
};
